import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import esLocale from "@fullcalendar/core/locales/es";
import "../../assets/styles/calendar.scss";
import moment from "moment";

const CardCalendar = ({ promotions }) => {

  const date1 = moment().format("YYYY-MM-DD");
  const date2Default = moment(date1).add(1, "M").format("YYYY-MM-DD");

  const [date2, setDate2] = useState(date2Default);

  const prev = () => {
    document.querySelector("#secondary-calendar .fc-prev-button").click();
  };

  const next = () => {
    document.querySelector("#secondary-calendar .fc-next-button").click();
  };

  const toDay = () => {
    document.querySelector("#secondary-calendar .fc-today-button").click();
    document.querySelector("#secondary-calendar .fc-next-button").click();
  }

  useEffect(() => {
    document
      .querySelector("#main-calendar .fc-prev-button")
      .addEventListener("click", prev);
    document
      .querySelector("#main-calendar .fc-next-button")
      .addEventListener("click", next);
    document
      .querySelector("#main-calendar .fc-today-button")
      .addEventListener("click", toDay);
  }, []);

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#83BF6E" />
          <span className="fs-5 ms-3 me-auto">Calendario</span>
        </div>
      </Card.Header>
      <Card.Body className="px-5">
        <Row>
          <Col col={12} sm={6} id="main-calendar">

            <FullCalendar
              datesSet={(d) => setDate2(moment(d.endStr).format("YYYY-MM-DD"))}
              initialDate={date1}
              defaultView="dayGridDay"
              locale={esLocale}
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              weekends={true}
              events={promotions.map((p) => ({
                title: p.DESCRIPCION_PROMO,
                start: p.FECHA_INICIO,
                end: moment(p.FECHA_TERMINO).add(1, 'd').format("YYYY-MM-DD"),
                color: p.COLOR,
              }))}
            />
          </Col>

          <Col col={12} sm={6} id="secondary-calendar" className="calendar-2">
            <FullCalendar
              initialDate={date2}
              defaultView="dayGridDay"
              locale={esLocale}
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              weekends={true}
              events={promotions.map((p) => ({
                title: p.DESCRIPCION_PROMO,
                start: p.FECHA_INICIO,
                end: moment(p.FECHA_TERMINO).add(1, 'd').format("YYYY-MM-DD"),
                color: p.COLOR,
              }))}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CardCalendar;
